import $ from 'jquery';

global.$ = $;
global.jQuery = $;

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import './app';
import './swiper';
import './site';
import './compatibility';
import './acronyms';
import './vendor/appear';
import './vendor/infiniteScroll';
import './userway-loader';